export default __webpack_public_path__ + "static/uudet-tilat-75d3fa2ce9a0008d75a95f324de947c7.jpeg";